<template>
    <div class="performanceStatistics">
        <div class="search">
            <el-date-picker class="choiceDate" value-format="yyyy-MM-dd HH:mm:ss" v-model="time" start-placeholder="开始日期"
                end-placeholder="结束日期" :picker-options="pickerOptions" type="datetimerange"></el-date-picker>
            <el-input v-model.trim="params.keyword" placeholder="输入推广员/上级推广员昵称"></el-input>
            <el-button @click.native="search">搜索</el-button>
        </div>
        <el-table :data="tableData" style="width: 100%" :default-sort = "{prop: 'date', order: 'descending'}">
            <el-table-column label="序号" width="100px" class-name="center">
                <template slot-scope="scope">
                    <div>
                        {{scope.row.sort + ($refs.page.page.page - 1) * 10}}
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="promoternickname" label="推广员昵称" class-name="center"></el-table-column>
            <el-table-column prop="promotermobileno" label="手机号" class-name="center"></el-table-column>
            <el-table-column prop="ordernum" label="直接推广订单数" sortable class-name="center"></el-table-column>
            <el-table-column prop="totalordermoney" label="直接推广金额" sortable class-name="center"></el-table-column>
            <el-table-column prop="totalordercountsecond" label="间接推广订单数" sortable class-name="center"></el-table-column>
            <el-table-column prop="totalordermoneysecond" label="间接推广金额" sortable class-name="center"></el-table-column>
            <el-table-column prop="currentbrokerage" label="累计收益" sortable class-name="center"></el-table-column>
        </el-table>
        <Page ref="page" :total="total"></Page>
    </div>
</template>
<script>
import {statisticalList} from '@/api/extensionAgent'
import {mapGetters, mapActions} from 'vuex'
import Page from '@/base/page/page'
export default {
    name: 'buyerBindingCheck',
    data() {
        return {
            params: {
                beginTime: '',
                endTime: '',
                keyword: ''
            },
            time: '',
            total: 0,
            tableData: [],
            pickerOptions: {
                shortcuts: [
                    {
                        text: '今天',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一周',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近一个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
                            picker.$emit('pick', [start, end])
                        }
                    },
                    {
                        text: '最近三个月',
                        onClick(picker) {
                            const end = new Date()
                            const start = new Date()
                            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
                            picker.$emit('pick', [start, end])
                        }
                    }
                ]
            }
        }
    },
    mounted() {
        this.getStatisticalList()
    },
    methods: {
        getStatisticalList() {
            this.setLoading(true)
            statisticalList({
                data: Object.assign({}, this.params, this.$refs.page.page),
                success: data => {
                    this.setLoading(false)
                    data.data.forEach((obj, index) => {
                        obj.sort = index + 1
                    })
                    this.tableData = data.data
                    this.total = data.pageableData.rowCount
                    console.log(data)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        search() {
            this.getStatisticalList()
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {
        'time': {
            handler(newV, oldV) {
                if (!newV) {
                    this.params.beginTime = ''
                    this.params.endTime = ''
                } else {
                    this.params.beginTime = newV[0]
                    this.params.endTime = newV[1]
                }
            }
        }
    },
    components: {
        Page
    }
}
</script>
<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
    .performanceStatistics{
        .search{
            margin-top: 15px;
            .choiceDate{
                width: 224px;
                margin-right: 30px;
                .el-input__icon{
                    line-height: 24px;
                }
                .el-range-separator{
                    line-height: 24px;
                }
            }
            .el-input{
                width: 330px;
                margin-right: 30px;
            }
        }
        .el-table{
            margin-top: 30px;
            .center{
                .cell{
                    text-align: center;
                }
            }
        }
    }
</style>